module.exports = __webpack_public_path__ + "static/media/shoes03.ac1cca68.png";